import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderSlot as _renderSlot, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, normalizeStyle as _normalizeStyle, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-31b624a9"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "page-header" }
const _hoisted_2 = {
  key: 0,
  class: "pc-header-padding"
}

import { computed } from 'vue'
import { useRouter } from 'vue-router'
import { isAndroidNative as isAndroid, isIOSNative as isIOS } from '@xunlei/universal-native-api'
import { store } from '@remote/store'
import { useEnvStore } from '@remote/store/env'


export default /*#__PURE__*/_defineComponent({
  props: {
    title: null,
    bg: null
  },
  setup(__props: any, { emit }: { emit: ({
  onClose: () => void
}), expose: any, slots: any, attrs: any }) {

const props = __props as {title:string; bg?:string}




const router = useRouter()
const envStore = useEnvStore()
const isFullScreen = computed(() => store.getters.isFullScreen)
const handleBack = () => {
  router.go(-1)
  emit('onClose')
}


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(["more-info", { 'sl-full': _unref(isFullScreen), 'android-padding': _unref(isAndroid), 'ios-padding': _unref(isIOS) }]),
    style: _normalizeStyle({background: props.bg || '#f2f4f6'})
  }, [
    _createElementVNode("div", _hoisted_1, [
      (_unref(envStore).isInPC)
        ? (_openBlock(), _createElementBlock("div", _hoisted_2))
        : _createCommentVNode("", true),
      _renderSlot(_ctx.$slots, "left", {}, () => [
        _createElementVNode("a", {
          href: "javascript:;",
          class: "qh-icon-back",
          title: "返回",
          onClick: handleBack
        })
      ]),
      _renderSlot(_ctx.$slots, "title", {}, () => [
        _createElementVNode("h1", null, _toDisplayString(props.title), 1)
      ]),
      _renderSlot(_ctx.$slots, "right")
    ]),
    _renderSlot(_ctx.$slots, "default")
  ], 6))
}
}

})